"use strict";

module.exports = function (column) {
  if (!this.opts.filterable) return false;
  if (this.isTextFilter(column)) return 'vt-text-filter';
  if (this.isDateFilter(column)) return 'vt-date-filter';
  if (this.isListFilter(column)) return 'vt-list-filter';
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-tables-2/compiled/methods/filter-type.js
// module id = ljF2
// module chunks = 71